import L from "leaflet";
const createButton = (image, container,name) => {
  //creazione dei button che vengono poi richiamati in CreateDiv.js
    var btn = L.DomUtil.create('button', '', container);
    btn.setAttribute('type', 'button');
    btn.innerHTML = `<button class="divNameButton">${name}<img src="${image}" class="imageStylePopUp" alt="image" ></button>`
    return btn;
  };

  export default createButton